<template>
  <prototype-attribute-table attribute-name="material" />
</template>

<script>
import PrototypeAttributeTable from '../components/PrototypeAttributeTable.vue'

export default {
  components: {
    PrototypeAttributeTable
  }
}
</script>

<style scoped>
</style>
